import React from 'react';
import clsx from 'clsx';
import { ChevronRight, Plus } from 'lucide-react';

type ButtonProps = {
    size?: 'small' | 'medium' | 'large';
    variant?: 'primary' | 'black-primary' | 'secondary' | 'black-secondary';
    shape?: 'rounded' | 'circle' | 'square';
    state?: 'default' | 'hover' | 'clicked' | 'disabled';
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    children?: React.ReactNode;
    customClassName?: string;
    icon?: React.ReactNode;
    onClick?: () => void;
    loading?: boolean;
};

const Button: React.FC<ButtonProps> = ({
    size = 'medium',
    variant = 'primary',
    shape = 'rounded',
    state = 'default',
    leftIcon = true,
    rightIcon = true,
    children,
    customClassName,
    icon,
    onClick,
    loading = false,
}) => {

    return (
        <button
            className={clsx(
                'button',
                size,
                variant,
                shape,
                state,
                icon && 'icon',
                customClassName
            )}
            onClick={onClick}
            disabled={state === 'disabled'}
        >
            {
                loading ? (
                    <span className="animate-spin border-3 border-t-transparent border-[text-color-default] rounded-full w-6 h-6" />
                ) : (
                    <>
                        {icon && icon}
                        {!!leftIcon && leftIcon}
                        {children}
                        {!!rightIcon && rightIcon}
                    </>
                )}
        </button>
    );
};

export default Button;
